const tokenActionTypes = {
  FETCH_TOKEN_REQUEST: 'FETCH_TOKEN_REQUEST',
  SET_TOKEN_ERROR: 'SET_TOKEN_ERROR',
  CREATE_TOKEN_SUCCESS: 'CREATE_TOKEN_SUCCESS',
  CREATE_TOKEN_FAILURE: 'CREATE_TOKEN_FAILURE',
  DOWNLOAD_TOKEN_FAILURE: 'DOWNLOAD_TOKEN_FAILURE',
  DOWNLOAD_TOKEN_SUCCESS: 'DOWNLOAD_TOKEN_SUCCESS',
  COPY_TOKEN_FAILURE: 'COPY_TOKEN_FAILURE',
  COPY_TOKEN_SUCCESS: 'COPY_TOKEN_SUCCESS',
  REMOVE_CREATE_TOKEN_SUCCESS_MESSAGE: 'REMOVE_CREATE_TOKEN_SUCCESS_MESSAGE',
  REMOVE_TOKEN_ERROR: 'SET_TOKEN_ERROR',
  SET_TOKEN_COPIED_MESSAGE: 'SET_TOKEN_COPIED_MESSAGE',
  REMOVE_TOKEN_COPIED_MESSAGE: 'REMOVE_TOKEN_COPIED_MESSAGE',
  REMOVE_TOKEN_DETAILS: 'REMOVE_TOKEN_DETAILS',
  TOKEN_START_FETCH: 'TOKEN_START_FETCH',
  FETCH_TOKEN_SUCCESS: 'FETCH_TOKEN_SUCCESS',
  FETCH_TOKEN_FAILURE: 'FETCH_TOKEN_FAILURE',
  DELETE_REGISTRATION_TOKEN_SUCCESS: 'DELETE_REGISTRATION_TOKEN_SUCCESS',
  DELETE_REGISTRATION_TOKEN_FAILURE: 'DELETE_REGISTRATION_TOKEN_FAILURE',
  REMOVE_DELETE_TOKEN_DATA_SUCCESS_MESSAGE: 'REMOVE_DELETE_TOKEN_DATA_SUCCESS_MESSAGE',
  TOKEN_FILTER_REQUEST: 'TOKEN_FILTER_REQUEST',
  TOKEN_FILTER_SUCCESS: 'TOKEN_FILTER_SUCCESS',
  TOKEN_FILTER_FAILURE: 'TOKEN_FILTER_FAILURE',
};

export default tokenActionTypes;
